(function () {
  function clamp(value, min, max) {
    return Math.min(Math.max(value, min), max);
  }

  function initHeroPush(root) {
    var openLayer = root.querySelector('[data-hero-layer="open"]');
    var destLayer = root.querySelector('[data-hero-layer="dest"]');
    var video = root.querySelector('[data-hero-video]');
    var wordmark = root.querySelector('[data-hero-text="wordmark"]');
    var caption = root.querySelector('[data-hero-text="caption"]');
    var scrollCue = root.querySelector('[data-hero-scroll-cue]');
    var track = root.querySelector('.hero-push__track');

    if (!track || !openLayer || !destLayer) return;

    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
      return;
    }

    if (video) {
      var playPromise = video.play();
      if (playPromise && playPromise.catch) {
        playPromise.catch(function () {});
      }
    }

    var ticking = false;
    var lastProgress = -1;
    var videoPaused = false;

    function render(progress) {
      var openScale = 1 + progress * 0.9;
      var openOpacity = clamp(1 - progress * 2.4, 0, 1);
      var openBlur = 2.5 + progress * 16;
      var openY = progress * -40;

      openLayer.style.transform = 'scale(' + openScale + ') translateY(' + openY + 'px)';
      openLayer.style.opacity = openOpacity;
      openLayer.style.filter = 'blur(' + openBlur + 'px)';

      if (video) {
        if (openOpacity < 0.02 && !videoPaused) {
          video.pause();
          videoPaused = true;
        } else if (openOpacity >= 0.02 && videoPaused) {
          var resumePromise = video.play();
          if (resumePromise && resumePromise.catch) {
            resumePromise.catch(function () {});
          }
          videoPaused = false;
        }
      }

      var destStart = 0.22;
      var destProgress = clamp((progress - destStart) / (1 - destStart), 0, 1);
      var destScale = 1.32 - destProgress * 0.32;
      var destOpacity = destProgress;
      var destBlur = (1 - destProgress) * 9;
      var destY = (1 - destProgress) * 18;

      destLayer.style.transform = 'scale(' + destScale + ') translateY(' + destY + 'px)';
      destLayer.style.opacity = destOpacity;
      destLayer.style.filter = 'blur(' + destBlur + 'px)';

      if (wordmark) {
        var wordmarkOpacity = clamp(1 - progress * 3, 0, 1);
        var wordmarkScale = 1 + progress * 0.12;
        var wordmarkY = progress * -50;
        wordmark.style.opacity = wordmarkOpacity;
        wordmark.style.transform = 'scale(' + wordmarkScale + ') translateY(' + wordmarkY + 'px)';
      }

      if (caption) {
        var captionStart = 0.58;
        var captionProgress = clamp((progress - captionStart) / (1 - captionStart), 0, 1);
        caption.style.opacity = captionProgress;
        caption.style.transform = 'translateY(' + (1 - captionProgress) * 16 + 'px)';
      }

      if (scrollCue) {
        scrollCue.style.opacity = clamp(1 - progress * 5, 0, 1);
      }
    }

    function update() {
      ticking = false;
      var rect = track.getBoundingClientRect();
      var scrollable = rect.height - window.innerHeight;
      if (scrollable <= 0) {
        render(0);
        return;
      }
      var progress = clamp(-rect.top / scrollable, 0, 1);
      if (Math.abs(progress - lastProgress) < 0.0008) return;
      lastProgress = progress;
      render(progress);
    }

    function onScroll() {
      if (!ticking) {
        ticking = true;
        window.requestAnimationFrame(update);
      }
    }

    window.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener('resize', onScroll, { passive: true });
    update();
  }

  var roots = document.querySelectorAll('[data-hero-push]');
  for (var i = 0; i < roots.length; i++) {
    initHeroPush(roots[i]);
  }
})();
